<div class="vf-root" (pointerdown)="$event.stopPropagation()">
  <div class="row">
    <div class="label">fieldName</div>
    <label class="override">
      <input
        type="checkbox"
        [checked]="data.overrideFieldName"
        (change)="toggleOverride(($any($event.target)).checked)"
      />
      <span>override</span>
    </label>
  </div>

  @if (data.overrideFieldName) {
    <input
      class="text"
      [value]="data.fieldName"
      (input)="changeFieldName(($any($event.target)).value)"
      placeholder="quantity"
    />
  } @else {
    <div class="readonly">{{ data.fieldName || '（接続してください）' }}</div>
  }

  <div class="row mt">
    <div class="label">fieldType</div>
  </div>
  <select class="select" [value]="data.fieldType" (change)="changeFieldType(($any($event.target)).value)">
    <option value="">(未指定)</option>
    <option value="string">string</option>
    <option value="byte">byte</option>
    <option value="short">short</option>
    <option value="int">int</option>
    <option value="long">long</option>
    <option value="single">single</option>
    <option value="double">double</option>
    <option value="bool">bool</option>
    <option value="decimal">decimal</option>
    <option value="currency">currency</option>
    <option value="date">date</option>
    <option value="time">time</option>
    <option value="timestamp">timestamp</option>
    <option value="uuid">uuid</option>
    <option value="ulid">ulid</option>
    <option value="object">object</option>
  </select>
</div>

